// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import AmericanSamoa from '../_raw/flag/icon_flag_american_samoa.png';

export default () => <img src={AmericanSamoa} alt="AmericanSamoa" />;
